import React from 'react';

import { Card } from 'reactstrap';

import styles from './CourseBucketV2.module.scss';

export const CourseBucketSkeleton = () => (
  <div style={{ width: '90%', margin: '18px' }}>
    <Card className={styles.courseBucket} aria-hidden="true">
      <div className={`${styles.skeleton} ${styles.skeletonImage}`} />
      <div className={`${styles.skeleton} ${styles.skeletonTitle}`} />
      <div className={`${styles.skeleton} ${styles.skeletonTitleShort}`} />
      <div className={`${styles.skeleton} ${styles.skeletonPrice}`} />
      <div className={`${styles.skeleton} ${styles.skeletonButton}`} />
    </Card>
  </div>
);

const CourseBucket = props => (
  // <div className="col-12 mb-3 col-md-6 col-lg-4">
  <div style={{ width: '90%', margin: '18px' }}>
    <a href={props.link} style={{ textDecoration: 'none' }}>
      <Card className={styles.courseBucket}>
        <img
          src={props.image}
          height={props.imageHeight}
          className={styles.bucketImage}
          alt={props.name}
        />
        <a href={props.link} style={{ textDecoration: 'none' }}>
          <h4 className={styles.bucketTitle}>{props.name}</h4>
        </a>
        {props.fromPrice != null && (
          <p className={styles.fromPrice}>
            From &pound;{props.fromPrice.toLocaleString('en-GB')}
          </p>
        )}
        {/* <p className={styles.courseInfo}> Course Info Course Info Course Info Course Info</p> */}
        <a href={props.link} style={{ textDecoration: 'none' }}>
          <button className={styles.viewButton}>
            <p>View Courses</p>
          </button>
        </a>
      </Card>
    </a>
  </div>
);

export default CourseBucket;
